import { SvgIcon } from "@mui/material";

export default function PiratePeteIcon(props) {
  const { style, color, old, ...rest } = props;
  // const width = props.width || 24;

  if (old) {
    return (
      <SvgIcon {...rest}>
        <svg
          id="a"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 316.34 302.71"
        >
          <g>
            <path
              id="c"
              d="M290.24,.01c-5.6,.1-15.7,4.7-33.9,12.2-6.2,3.1-12.1,6.2-17.8,9.1C216.04,8.41,190.54,1.61,164.64,1.61,81.84,1.61,14.74,69.01,14.74,152.11h0c0,23.3,5.4,46.3,15.8,67.1-6.6,7.7-14.1,12.9-24.5,15.4-7.1,1.7-7.4,2.2-3.7,5.5,13.7,16.3,43.3,24.7,67.8,28.7,26.7,21.9,60.1,33.8,94.6,33.9,22.1-.1,43.9-5,63.8-14.5l23.5,7.7,26.5,2.3,3.7-12.6-4.9-34.2c24-27.4,37.3-62.7,37.4-99.2,0-13.7-1.9-27.4-5.6-40.6,4.7-27.1,6.4-54.6,7.2-79.8-1.4-50.6-12.8-21.3-14.5-16.1-3.1,9.8-4.2,15.7-4.7,3.3,0-13.6-.5-19.2-6.9-19Z"
              style={{ fill: "#e3dac9" }}
            />
            <g id="d">
              <path
                id="e"
                d="M159.64,194.41l18.4,42.8-5.6,5.6,4.8,28.6,74.6,24.6,26.5,2.3,3.7-12.6-6.4-44.5-4,12.7-13.5-14.3-14.3,15.1-5.4,.8-7.9-12.7-12.7,14.3-20.6-9.5-25.5-58.7-12.1,5.5Z"
                style={{ fill: "#000000", fillRule: "evenodd" }}
              />
              <path
                id="f"
                d="M213.84,229.31l10.3,16.7h13.5l23-13.5,17.5,11.1,4-5.6-3.2-7.9-11.1-11.9h-15.1l-19.1,15.9-19.8-4.8Z"
                style={{ fill: "#000000", fillRule: "evenodd" }}
              />
              <path
                id="g"
                d="M205.44,171.61c1.3-6.3,8.5-11.2,17.1-13.8,14.1-1.7,21.8,2.1,34.2,4.8l-6.4,11.1-30.1-6c-5.6,1.3-6.3,3.3-14.8,3.9Z"
                style={{ fill: "#000000", fillRule: "evenodd" }}
              />
              <path
                id="h"
                d="M263.84,161.81c-.2,3.7-5.1,7.4,0,11.1,8.3-2.1,14.7-4.1,23.7-2.5-5.9-5.9-15.6-6-23.7-8.6Z"
                style={{ fill: "#000000", fillRule: "evenodd" }}
              />
              <path
                id="i"
                d="M284.54,161.81l-25.4,7.9c-9.6,11.4-4.5,16.4-21.4,27.8-15.7,5.3-21.9-2.6-27.1-8.7-6.1-.6-43.4,20.3-59.3,27.2l5.8-11.4,51.2-26.2c13.4-13.8,22-11.3,40.9-14.6,11.4-5.2,20.7-7.3,32.1-10.8l3.2,8.8Z"
                style={{ fill: "#6b4328", fillRule: "evenodd" }}
              />
              <path
                id="j"
                d="M172.54,172.11l52.1-18.7c13-4.4,37.3-4.8,45.7-2.7l19,19.8,4.1-28.8c-34.3-23.8-58.6-20.6-97-9.8l-23.9,40.2Z"
                style={{ fill: "#a80f0f", fillRule: "evenodd" }}
              />
              <path
                id="k"
                d="M101.84,299.91l10.3-36.5,5.6-31.7,31-84.2,76.2-29.4c-8,19.8-24.3,40.7-23.8,69-.9-5-2.5-16.1-4-18.2-3.1,6.5-6.5,12.7-5.6,23.8-2.5-8.1-4.7-8.3-11.1-10.3-1.4,18-1.7,29.1-3.2,42.7-14.8-18,.4-24.7-16.6-21-.2,6.1-4.5,20.8-6.4,29.4-4-17.6-12.1-10.2-2.6,20.9,1,5.7,.4,15.2,1.3,25.6-12.6-16.8-7.8-23.2-15.2-27.7-.8,13.4-.5,28.1-1.1,40.5-6.4-9.6-3.6-23.1-10-23.9-9.1,6.7-15.8,18.4-24.8,31h0Z"
                style={{ fill: "#000000", fillRule: "evenodd" }}
              />
              <path
                id="l"
                d="M104.24,272.11c-16.1-.1-79.8-5.6-101.9-32-3.7-3.3-3.4-3.8,3.7-5.5,25.9-6.2,33.2-28.7,56.1-66.1C124.14,81.91,164.64,58.91,256.34,12.21c38.7-16,40.8-18.7,40.7,6.7,.5,12.4,1.6,6.5,4.7-3.3,1.7-5.1,13.1-34.5,14.5,16.1-1.5,50.6-7,110.5-32.5,157.8,1.9-14.8,7.3-34.9,5.6-44.5-10.9-11.7-5.8-14.6-36.5-18.3-55.5,2.7-81.7,38-112.8,77-15.5,34.4-30.1,60.1-35.8,68.4h0Z"
                style={{ fill: "#6b4328", fillRule: "evenodd" }}
              />
            </g>
          </g>
        </svg>
      </SvgIcon>
    );
  }
  return (
    <SvgIcon style={style} {...rest}>
      <svg
        // width={width}
        // height={width}
        // viewBox={`0 0 ${width} ${width}`}
        viewBox={`0 0 1080 1108`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_2074_60367)">
          <path
            d="M835.215 700.715L810.411 730.934L773.487 743.925L788.698 800.285L841.445 870.689L835.362 887.758L805.302 972.196L801.87 981.857L794.61 989.095L768.209 1015.41L764.822 1018.78L760.824 1021.36L681.415 1072.69L627.003 1107.87L612.641 1044.68L597.306 977.168L557.165 994.169L540.504 1001.23V1001.64L540.006 1001.43L539.507 1001.64V1001.23L522.835 994.169L482.706 977.168L467.359 1044.68L453.008 1107.87L398.585 1072.69L319.187 1021.36L315.178 1018.78L311.803 1015.41L285.401 989.095L278.141 981.857L274.698 972.196L244.638 887.758L238.567 870.689L291.302 800.285L306.525 743.925L269.589 730.934L244.796 700.715L229.607 676.261L224.273 641.048L238.238 603.32L92.9439 507.001L78.9785 498.053L74.0856 482.207L32.4839 347.299L0 242.01L97.146 294.009L117.726 305.018L201.473 234.5L307.952 99.2187L312.72 93.1591L319.221 89.025L414.986 28.0327L459 0L480.576 47.5253L519.675 133.651L540.006 149.089L560.336 133.651L599.435 47.5253L621 0L665.026 28.0327L760.79 89.025L767.28 93.1591L772.048 99.2187L878.527 234.5L962.274 305.018L982.854 294.009L1080 242.01L1047.53 347.299L1005.91 482.207L1001.02 498.053L987.056 507.001L841.762 603.32L855.739 641.048L850.404 676.261L835.215 700.715Z"
            fill="black"
          />
          <path
            d="M327.852 825.498L287.315 872.559L317.375 957.008L375.887 861.538L327.852 825.498Z"
            fill="white"
          />
          <path
            d="M343.777 983.319L423.186 1034.65L450.516 914.353L405.245 881.189L343.777 983.319Z"
            fill="white"
          />
          <path
            d="M752.488 779.999L699.526 791.405L605.97 669.715L540.504 708.859L475.038 669.715L381.471 791.405L328.52 779.999L388.097 825.497L458.683 774.88L519.562 730.673H540.504H561.446L622.325 774.88L692.9 825.497L752.488 779.999Z"
            fill="white"
          />
          <path
            d="M592.854 825.567V808.452L566.679 764.914H540.504H514.329L488.154 808.452V825.567L540.504 782.527L592.854 825.567Z"
            fill="white"
          />
          <path
            d="M540.504 826.324H530.129L477.802 887.736L540.504 952.443L603.207 887.736L550.868 826.324H540.504Z"
            fill="white"
          />
          <path
            d="M705.121 861.538L763.621 957.008L793.681 872.559L753.156 825.498L705.121 861.538Z"
            fill="white"
          />
          <path
            d="M630.492 914.353L657.822 1034.65L737.22 983.319L675.763 881.189L630.492 914.353Z"
            fill="white"
          />
          <path
            d="M313.943 689.82L320.615 669.025L306.491 681.178L288.357 672.343L281.539 652.182L295.651 640.029L274.097 643.54L271.3 658.559L280.463 680.113L298.676 690.341L313.943 689.82Z"
            fill="white"
          />
          <path
            d="M957.585 359.453L846.802 266.169L737.446 127.24L641.682 66.248L597.849 162.805L540.504 206.343L483.159 162.805L439.326 66.248L343.562 127.24L234.206 266.169L123.423 359.453L75.7732 333.946L117.386 468.843L220.071 534.615C220.071 534.615 281.346 478.923 283.838 474.891C284.574 473.702 230.14 464.81 230.14 464.81L370.745 376.216L540.504 346.847L710.263 376.216L850.868 464.81C850.868 464.81 796.434 473.702 797.17 474.891C799.662 478.923 860.937 534.615 860.937 534.615L963.622 468.843L1005.23 333.946L957.585 359.453V359.453Z"
            fill="white"
          />
          <path
            d="M614.624 410.67L499.389 550.913L540.504 571.617L654.13 514.397L707.703 525.723L691.054 485.865L754.73 510.274L681.392 422.732L614.624 410.67Z"
            fill="white"
          />
          <path
            d="M399.616 422.733L326.278 510.274L389.943 485.866L373.305 525.723L426.878 514.397L562.115 401.179L540.504 397.271L399.616 422.733Z"
            fill="white"
          />
          <path
            d="M769.885 586.093L761.537 547.855L738.885 605.269L720.751 578.312L653.326 638.206L614.193 590.567H591.812L690.929 732.622L690.782 614.171L724.24 668.073L769.885 586.093Z"
            fill="white"
          />
          <path
            d="M311.123 586.093L356.768 668.073L390.215 614.171L390.079 732.622L489.184 590.567H466.815L427.671 638.206L360.257 578.312L342.112 605.269L319.459 547.855L311.123 586.093Z"
            fill="white"
          />
          <path
            d="M530.82 590.318L504.566 645.67L540.504 680.465L576.431 645.67L550.177 590.318H540.504H530.82Z"
            fill="white"
          />
          <path
            d="M685.164 544.332L612.472 574.868H685.164V544.332Z"
            fill="white"
          />
          <path
            d="M767.121 689.82L760.45 669.025L774.563 681.178L792.708 672.343L799.526 652.182L785.402 640.029L806.967 643.54L809.754 658.559L800.602 680.113L782.389 690.341L767.121 689.82Z"
            fill="white"
          />
          <path
            d="M327.852 825.498L287.315 872.559L317.375 957.008L375.887 861.538L327.852 825.498Z"
            fill="white"
          />
          <path
            d="M343.777 983.319L423.186 1034.65L450.516 914.353L405.245 881.189L343.777 983.319Z"
            fill="white"
          />
          <path
            d="M752.488 779.999L699.526 791.405L605.97 669.715L540.504 708.859L475.038 669.715L381.471 791.405L328.52 779.999L388.097 825.497L458.683 774.88L519.562 730.673H540.504H561.446L622.325 774.88L692.9 825.497L752.488 779.999Z"
            fill="white"
          />
          <path
            d="M592.854 825.567V808.452L566.679 764.914H540.504H514.329L488.154 808.452V825.567L540.504 782.527L592.854 825.567Z"
            fill="white"
          />
          <path
            d="M540.504 826.324H530.129L477.802 887.736L540.504 952.443L603.207 887.736L550.868 826.324H540.504Z"
            fill="white"
          />
          <path
            d="M705.121 861.538L763.621 957.008L793.681 872.559L753.156 825.498L705.121 861.538Z"
            fill="white"
          />
          <path
            d="M630.492 914.353L657.822 1034.65L737.22 983.319L675.763 881.189L630.492 914.353Z"
            fill="white"
          />
          <path
            d="M313.943 689.82L320.615 669.025L306.491 681.178L288.357 672.343L281.539 652.182L295.651 640.029L274.097 643.54L271.3 658.559L280.463 680.113L298.676 690.341L313.943 689.82Z"
            fill="white"
          />
          <path
            d="M957.585 359.453L846.802 266.169L737.446 127.24L641.682 66.248L597.849 162.805L540.504 206.343L483.159 162.805L439.326 66.248L343.562 127.24L234.206 266.169L123.423 359.453L75.7732 333.946L117.386 468.843L220.071 534.615C220.071 534.615 281.346 478.923 283.838 474.891C284.574 473.702 230.14 464.81 230.14 464.81L370.745 376.216L540.504 346.847L710.263 376.216L850.868 464.81C850.868 464.81 796.434 473.702 797.17 474.891C799.662 478.923 860.937 534.615 860.937 534.615L963.622 468.843L1005.23 333.946L957.585 359.453V359.453Z"
            fill="white"
          />
          <path
            d="M614.624 410.67L499.389 550.913L540.504 571.617L654.13 514.397L707.703 525.723L691.054 485.865L754.73 510.274L681.392 422.732L614.624 410.67Z"
            fill="white"
          />
          <path
            d="M399.616 422.733L326.278 510.274L389.943 485.866L373.305 525.723L426.878 514.397L562.115 401.179L540.504 397.271L399.616 422.733Z"
            fill="white"
          />
          <path
            d="M769.885 586.093L761.537 547.855L738.885 605.269L720.751 578.312L653.326 638.206L614.193 590.567H591.812L690.929 732.622L690.782 614.171L724.24 668.073L769.885 586.093Z"
            fill="white"
          />
          <path
            d="M311.123 586.093L356.768 668.073L390.215 614.171L390.079 732.622L489.184 590.567H466.815L427.671 638.206L360.257 578.312L342.112 605.269L319.459 547.855L311.123 586.093Z"
            fill="white"
          />
          <path
            d="M530.82 590.318L504.566 645.67L540.504 680.465L576.431 645.67L550.177 590.318H540.504H530.82Z"
            fill="white"
          />
          <path
            d="M685.164 544.332L612.472 574.868H685.164V544.332Z"
            fill="white"
          />
          <path
            d="M767.121 689.82L760.45 669.025L774.563 681.178L792.708 672.343L799.526 652.182L785.402 640.029L806.967 643.54L809.754 658.559L800.602 680.113L782.389 690.341L767.121 689.82Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_2074_60367">
            <rect width="1080" height="1107.87" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
